import { Typography, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles((theme) => {
  const COLORS = Object.entries(theme.colors).reduce(
    (obj, [key, val]) => ({ ...obj, [key]: { color: val } }),
    {},
  );

  return {
    text: {
      fontSize: 10,
      lineHeight: "10px",
      fontFamily: "Larsseit-Light",
      "& > em": {
        fontFamily: "Larsseit-Medium",
        fontStyle: "normal",
      },
    },
    multiline: {
      lineHeight: "14px",
    },
    ellipsis: {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
    obscure: {
      filter: "blur(3px)",
      userSelect: "none",
    },
    ...COLORS,
  };
});

function Tiny({ children, ...props }) {
  const css = useStyles();
  const classnames = Object.keys(props)
    .map((k) => props[k] && css[k])
    .join(" ");

  return <Typography className={`${css.text} ${classnames}`}>{children}</Typography>;
}

Tiny.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default React.memo(Tiny);
